import axios from "axios";
import React, { useEffect, useState } from "react";
import { CUST_ID } from "../../constants";
import CancelRequest from "./CancelRequest";

import { capitalizeFirstLetter } from "../../components/reusableComponent/CapitalLetter";
import ReactModal from "react-modal";
import RescheduleAppointment from "./RescheduleAppointment";
import useThemeColors from "../vehicle/ThemeColors";


const Request = () => {
    const [bookingData, setBookingData] = useState([]);
    const [openCancelServiceRequestModal, setOpenCancelServiceRequestModal] =
        useState(false);
    const [getServiceRequestData, setGetServiceRequestData] = useState({});
    const [openRescheduleModal, setOpenRescheduleModal] = useState(false)

    const customerid = localStorage.getItem(CUST_ID);

    const fetchingTenant = window.location.hostname.split(".")[0];
    const apiPort = process.env.REACT_APP_API_PROTOCOL;
    const token = localStorage.getItem("customer-token");

    const fetchServiceRequestAPI = async () => {
        try {
            const response = await axios.get(
                `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/gc/booking-requests/?customer_id=${customerid}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            setBookingData(response?.data?.data);
        } catch (error) {
            console.error("Error fetching profile:", error);
        }
    };

    useEffect(() => {
        fetchServiceRequestAPI();
    }, []);

    const closeModal = () => {
        setOpenCancelServiceRequestModal(false);
        setOpenRescheduleModal(false)
    };

    const { selectedColor } = useThemeColors();


        const customModalStyles1: ReactModal.Styles = {
            content: {
                top: "50%",
                left: "50%",
                right: "auto",
                bottom: "auto",
                marginRight: "-50%",
                transform: "translate(-40%, -50%)",
                width: "30%",
                border: "none",
                boxShadow: `${selectedColor}80 1px 1px 10px 1px`,
                borderRadius: "40px",
                padding: "5px",
            },
        };


    return (
        <div className="customer-vehicle-info__table-container">

            {/* <FilterDropdown /> */}
              {/* <div
                  style={{
                    marginRight: "20px",
                    width: "100%",
                    display: "flex",
                    justifyContent: "end",

                    padding: "20px"
                  }}
                >
                  <Button
                    variant="outlined"
                    className="text-hover-primary"
                 
                    sx={{
                      height: 40,
                      width: "10%",
                      border: "1px solid #ccc",
                      display: "flex",
                      gap: "10px",
                      overflow: "hidden",
                    }}
                  >
                    <i className="bi bi-filter text-dark fs-2" />
                    <span
                      className=" me-2 text-dark"
                      style={{
                        fontSize: "14px",
                        whiteSpace: "nowrap",
                        width: "100%",
                        textTransform: "none",
                      }}
                    >
                      Search filter
                    </span>
                  </Button>
                </div> */}
          
            <table className="customer-vehicle-info__table">
                <thead>
                    <tr>
                        <th>Request id</th>
                        <th>Service </th>
                        <th>Sub service</th>
                        <th>Service date</th>
                        <th>Workshop</th>
                        <th>Vehicle number</th>
                        <th style={{ whiteSpace: "nowrap" }}>
                            Workshop address
                        </th>
                        <th>Status</th>
                        <th>Actions</th>
                    </tr>
                </thead>

                <tbody>
                    {bookingData?.filter(vehicle => vehicle.status !== "accepted").map((vehicle) => (
                        <tr key={vehicle.id} className="vehicle-info__row">
                            <td className="customer-vehicle-info__cell">
                                {vehicle?.id}
                            </td>
                            <td className="customer-vehicle-info__cell">
                                {vehicle?.service_details[0]?.name}
                            </td>
                            <td className="customer-vehicle-info__cell">
                                {
                                    vehicle?.service_details[0]?.sub_services[0]
                                        ?.name
                                }
                            </td>
                            <td className="customer-vehicle-info__cell">
                                {vehicle?.service_date}
                            </td>
                            <td className="customer-vehicle-info__cell">
                                {vehicle?.workshop_details?.workshopName}
                            </td>
                            <td
                                style={{
                                    width: "200px",
                                    maxWidth: "200px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                }}
                                className="customer-vehicle-info__cell"
                                data-toggle="tooltip"
                                data-placement="top"
                                title={vehicle?.vehicle_details?.vehicle_number}
                            >
                                {vehicle?.vehicle_details?.vehicle_number}
                            </td>
                            <td
                                style={{
                                    width: "200px",
                                    maxWidth: "200px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                }}
                                className="customer-vehicle-info__cell"
                                data-toggle="tooltip"
                                data-placement="top"
                                title={vehicle?.workshop_details?.address}
                            >
                                {vehicle?.workshop_details?.address}
                            </td>

                            <td className="customer-vehicle-info__cell" style={{color: vehicle?.status === "cancelled"  ? "red" : "black"}}>
                                {capitalizeFirstLetter(vehicle?.status)}
                            </td>

                            {vehicle?.status !== "cancelled" && (
                                <td
                                    className="customer-vehicle-info__cell"
                                    style={{gap: "5px"}}
                                 
                                >
                                    <span style={{
                                         cursor: "pointer",
              background: "#f15a22",
              padding: "5px",
              borderRadius: "25px",
            //   display: "flex",
            //   alignItems: "center",




                                    }}    onClick={() => {
                                        setOpenCancelServiceRequestModal(true);
                                        setGetServiceRequestData(vehicle);
                                    }}>
                                        <i
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            title="Cancel"
                                            className="bi bi-x-circle"
                                            style={{color: "white", fontSize:"17px"}}
                                        ></i>
                                    </span>
                                    <span  style={{
                                           cursor: "pointer",
              background: "#f15a22",
              padding: "5px",
              borderRadius: "25px",
              marginLeft: "10px"
                                    }}
                                    onClick={() => {
                                             setOpenRescheduleModal(true);
                                        setGetServiceRequestData(vehicle);
                                    }}
                                    >
                                        <i
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            title="Reschedule"
                                            className="bi bi-arrow-repeat"
                                            style={{
                                                fontSize: "17px",
                                                color: "white",
                                            }}
                                        ></i>
                                    </span>
                                </td>
                            )}
                        </tr>
                    ))}
                </tbody>
            </table>
            {openCancelServiceRequestModal && (
                <CancelRequest
                    onClose={closeModal}
                    serviceData={getServiceRequestData}
                    fetchServiceRequestAPI={fetchServiceRequestAPI}
                    selectedTab={undefined}

                />
            )}


            <ReactModal
                isOpen={openRescheduleModal}
                onRequestClose={closeModal}
                style={customModalStyles1}
            >
                <RescheduleAppointment
                    closeModal={closeModal}
                    refetch={fetchServiceRequestAPI}
                    requestedId={getServiceRequestData}
                    refetch2={fetchServiceRequestAPI}
                    selectedTab={undefined}

                />
            </ReactModal>
        </div>
    );
};

export default Request;
